<template>
  <form
    class="fdt-filter-form p-2"
    @submit.prevent>
    <b-row fluid align-h="start">
      <b-col v-for="(filter, index) in all_filters"
             :key="index"
             sm="12"
             md="6"
             lg="4"
             xl="3"
             class="mb-2 fdt-filters-filter">
        <slot v-if="$scopedSlots[filter.name]" :name="filter.name" :filter-change="({ client, server }) => filterChange({ client, server }, filter)" />
        <div v-else :key="index"
             class="tbl-filter-item">
          <label :for="filter.name">{{ filter.display ? filter.display : filter.name }}</label>
          <b-input-group>
            <b-input-group-prepend v-if="filter.prepend">
              <div class="input-group-text">
                <i :class="filter.prepend" />
              </div>
            </b-input-group-prepend>
            <input :name="filter.name"
                   :type="nullishChain(filter.type, `text`)"
                   class="form-control"
                   @input="(event) => filterChange({
                     client: filter.client || { op: `ct`, value: event.target.value, field: filter.name, type: `scalar` },
                     server: filter.server || { op: `ct`, value: event.target.value, field: filter.name, type: `scalar` }
                   }, filter)">
          </b-input-group>
        </div>
      </b-col>
    </b-row>
  </form>
</template>

<script>

// helpers
const type_check = (...type) => val => type.some(t => typeof val === t);
const construct_slot_filter = name => ({
  name: name,
  type: `slot`,
});

export default {
  props: {
    target: {
      required: true,
      type: String,
    },
    expanded: {
      required: false,
      type: Boolean,
      default: true,
    },
    accordion: {
      required: false,
      type: String,
      default: ``,
    },
    filters: {
      type: Array,
      required: false,
      default: () => ([]),
      validator: arr => arr.every((filter_obj) => {
        const checks = Object.entries({
          name: type_check(`string`),
          display: type_check(`string`, `undefined`),
          type: type_check(`string`, `undefined`),
        });
        return checks.every(([key, validator]) => validator(filter_obj[key]));
      }),
    },
    debounceTimeout: {
      type: Number,
      required: false,
      default: 600,
    },
  },
  data() {
    return {
      all_filters: this.filters,
      debounce: null,
    };
  },
  mounted() {
    this.all_filters = [
      ...this.filters,
      ...Object.entries(this.$scopedSlots)
        .filter(slot_col => !this.all_filters.map(f => f.name).includes(slot_col[0]))
        .map(slot_col => construct_slot_filter(slot_col[0])),
    ];
  },
  methods: {
    filterChange(options, filter) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        window.EventBus.$emit(`fdt-filter-change`, {
          id: this.target,
          ...filter,
          ...options,
        });
      }, this.debounceTimeout);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "~AssetsSass/_variables" as *;

:deep(.tbl-filter-item) {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;

  label {
    font-weight: bolder;
  }
}

</style>
